<template>
  <div class="box">
    <div class="bar-cla">
      <div :style="itemStyle"></div>
      <div :style="itemStyle"></div>
      <div :style="itemStyle"></div>
      <div :style="itemStyle"></div>
      <div :style="itemStyle"></div>
    </div>
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    itemStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        margin: this.margin + 'px',
        borderRadius: this.borderRadius + 'px'
      }
    }
  },
  props: {
    text: {
      type: String,
      default: function() {
        return this.$t('common.loginLoading')
      }
    },
    width: {
      type: Number,
      default: 30
    },
    height: {
      type: Number,
      default: 70
    },
    margin: {
      type: Number,
      default: 15
    },
    borderRadius: {
      type: Number,
      default: 10
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="less">
.box p {
  text-align: center;
  width: 100%;
  margin: 0;
  padding: 0;
}
.bar-cla {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bar-cla div {
  background-color: hotpink;
  border-radius: 10px;
}
.bar-cla div:nth-child(1) {
  background-color: lightcoral;
  /*缩、放 这是两次，所以是2*/
  /*animation:loading 0.5s ease 0s 2 alternate;*/
  animation: loading 0.5s ease 0s infinite alternate;
}
.bar-cla div:nth-child(2) {
  background-color: darkorange;
  animation: loading 0.5s ease 0.1s infinite alternate;
}
.bar-cla div:nth-child(3) {
  background-color: lightcoral;
  animation: loading 0.5s ease 0.2s infinite alternate;
}
.bar-cla div:nth-child(4) {
  background-color: gold;
  animation: loading 0.5s ease 0.3s infinite alternate;
}
.bar-cla div:nth-child(5) {
  background-color: burlywood;
  animation: loading 0.5s ease 0.4s infinite alternate;
}

@keyframes loading {
  from {
    /*缩放y轴*/
    transform: scaleY(1);
  }

  to {
    transform: scaleY(0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadding.vue